export default __webpack_public_path__ + "218c39b37a757fde4a2576d0cd6664db.woff2";